/**
 * 買取査定のヘッダー通知（ベルバッジ・ドロワー一覧）
 * Realtime を主軸に即時反映し、短いポーリングはフォールバックのみ。
 */
(function () {
  const SUPABASE_URL = 'https://ozddinkzagrabhjziczu.supabase.co';
  const SUPABASE_KEY =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im96ZGRpbmt6YWdyYWJoanppY3p1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUzMTI5OTksImV4cCI6MjEwMDg4ODk5OX0.T6IsiUcCtbAQMxEZY--FfnMtk76D-h8_fty1V-J_qjc';
  const FALLBACK_POLL_MS = 2000;
  /** お知らせ保持期間（完了後も残す。この期間を超えたものだけ消す） */
  const NOTIFICATION_RETENTION_MONTHS = 3;

  let db = null;
  let pollTimer = null;
  let visibilityTimer = null;
  let realtimeChannel = null;
  let messagesChannel = null;
  let activeRequestId = null;
  let currentOfferIds = [];
  let cachedOffers = [];
  let cachedUserNotifications = [];
  let initialized = false;
  let refreshInFlight = null;
  let refreshQueued = false;
  let lastOfferFingerprint = '';
  let reconnectAttempts = 0;
  let reconnectTimer = null;
  const MAX_RECONNECT_DELAY = 30000;
  const REALTIME_STATUS = {
    LIVE: 'live',
    CONNECTING: 'connecting',
    RECONNECTING: 'reconnecting',
    OFFLINE: 'offline',
  };
  let channelStatuses = { global: 'connecting', request: null };

  function getConfig() {
    return window.__buybackNotificationConfig || {};
  }

  function getBuybackCustomerId() {
    const config = getConfig();
    if (config.shopifyCustomerId) {
      return 'shopify_' + config.shopifyCustomerId;
    }
    return localStorage.getItem('guest_buyback_id');
  }

  function getHeaderUserId() {
    const config = getConfig();
    if (config.headerUserId) return config.headerUserId;
    // 買取ゲストIDと揃えて、振込完了などのお知らせがベルに届くようにする
    var buybackGuest = localStorage.getItem('guest_buyback_id');
    if (buybackGuest) {
      try { localStorage.setItem('guest_user_id', buybackGuest); } catch (e) {}
      return buybackGuest;
    }
    let guestId = localStorage.getItem('guest_user_id');
    if (!guestId) {
      guestId = 'guest_' + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
      localStorage.setItem('guest_user_id', guestId);
    }
    return guestId;
  }

  // ベル通知の受信キー（ログイン顧客 + 買取ゲストIDの両方を見る）
  function getNotificationUserIds() {
    var ids = [];
    var headerId = getHeaderUserId();
    if (headerId) ids.push(headerId);
    var buybackId = getBuybackCustomerId();
    if (buybackId && ids.indexOf(buybackId) < 0) ids.push(buybackId);
    // shopify_123 ↔ customer_123 の両方
    ids.slice().forEach(function (id) {
      if (String(id).indexOf('shopify_') === 0) {
        var alt = 'customer_' + String(id).slice('shopify_'.length);
        if (ids.indexOf(alt) < 0) ids.push(alt);
      } else if (String(id).indexOf('customer_') === 0) {
        var alt2 = 'shopify_' + String(id).slice('customer_'.length);
        if (ids.indexOf(alt2) < 0) ids.push(alt2);
      }
    });
    return ids;
  }

  function getNotificationCutoffDate() {
    var d = new Date();
    d.setMonth(d.getMonth() - NOTIFICATION_RETENTION_MONTHS);
    return d;
  }

  function getNotificationCutoffIso() {
    return getNotificationCutoffDate().toISOString();
  }

  function isWithinNotificationRetention(iso) {
    if (!iso) return false;
    var t = new Date(iso).getTime();
    if (isNaN(t)) return false;
    return t >= getNotificationCutoffDate().getTime();
  }

  function filterByNotificationRetention(rows) {
    return (rows || []).filter(function (row) {
      return row && isWithinNotificationRetention(row.created_at);
    });
  }

  async function purgeExpiredUserNotifications(userIds) {
    if (!db || !userIds || !userIds.length) return;
    try {
      await db
        .from('user_notifications')
        .delete()
        .in('user_id', userIds)
        .lt('created_at', getNotificationCutoffIso());
    } catch (e) {}
  }

  async function fetchUserNotifications() {
    if (!db) return [];
    try {
      const userIds = getNotificationUserIds();
      if (!userIds.length) return [];
      purgeExpiredUserNotifications(userIds);
      const { data, error } = await db
        .from('user_notifications')
        .select('*')
        .in('user_id', userIds)
        .gte('created_at', getNotificationCutoffIso())
        .order('created_at', { ascending: false });
      if (error) return [];
      return filterByNotificationRetention(data || []);
    } catch (e) {
      return [];
    }
  }

  function isOfferMessage(content) {
    return (
      !!content &&
      (content.startsWith('[OFFER_PRICE]:') || content.startsWith('[FINAL_OFFER]:'))
    );
  }

  function isOfferUnread(offerId) {
    if (offerId == null) return false;
    const id = String(offerId);
    // 新方式: 最後に見た最新査定IDより新しいもの
    const seenLatest = localStorage.getItem('bell_seen_latest_offer');
    if (seenLatest && cachedOffers.length) {
      const latestId = String(cachedOffers[cachedOffers.length - 1].id);
      if (id === latestId) {
        return seenLatest !== latestId;
      }
    }
    return localStorage.getItem('bell_read_' + id) !== 'true';
  }

  function hasUnreadBuybackOffers() {
    return getUnreadOfferCount() > 0;
  }

  function getUnreadOfferCount() {
    return (cachedOffers || []).filter(function (m) {
      return isOfferUnread(m.id);
    }).length;
  }

  function getUnreadUserCount() {
    return (cachedUserNotifications || []).filter(function (n) {
      return !n.is_read;
    }).length;
  }

  function getTotalUnreadCount() {
    return getUnreadOfferCount() + getUnreadUserCount() + getShopNewsUnreadCount();
  }

  const SHOP_NEWS_SEEN_KEY = 'shop_news_seen_ids';

  function getShopNewsItems() {
    const el = document.getElementById('header-shop-news-data');
    if (!el) return [];
    try {
      const data = JSON.parse(el.textContent);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function getSeenShopNewsIds() {
    const raw = localStorage.getItem(SHOP_NEWS_SEEN_KEY);
    if (raw === null) {
      const ids = getShopNewsItems().map(function (p) {
        return String(p.id);
      });
      localStorage.setItem(SHOP_NEWS_SEEN_KEY, JSON.stringify(ids));
      return ids;
    }
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function getShopNewsUnreadCount() {
    const seen = getSeenShopNewsIds();
    return getShopNewsItems().filter(function (p) {
      return seen.indexOf(String(p.id)) === -1;
    }).length;
  }

  function markShopNewsAsRead() {
    const ids = getShopNewsItems().map(function (p) {
      return String(p.id);
    });
    localStorage.setItem(SHOP_NEWS_SEEN_KEY, JSON.stringify(ids));
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderShopNews() {
    const listEl = document.getElementById('header-shop-news-list');
    if (!listEl) return;
    const seen = getSeenShopNewsIds();
    const items = getShopNewsItems();
    if (!items.length) {
      listEl.innerHTML = '';
      return;
    }
    listEl.innerHTML = items
      .map(function (p) {
        const unread = seen.indexOf(String(p.id)) === -1;
        const img = p.image
          ? '<img class="header-shop-news-item__image" src="' +
            escapeHtml(p.image) +
            '" alt="" width="44" height="44">'
          : '<span class="header-shop-news-item__image"></span>';
        return (
          '<a class="header-shop-news-item' +
          (unread ? ' is-unread' : '') +
          '" href="' +
          escapeHtml(p.url) +
          '">' +
          img +
          '<span class="header-shop-news-item__body">' +
          '<span class="header-shop-news-item__label">' +
          (unread ? '新着' : '商品') +
          '</span>' +
          '<span class="header-shop-news-item__title">' +
          escapeHtml(p.title) +
          '</span></span></a>'
        );
      })
      .join('');
  }

  function ensureBadgeElement() {
    let badgeEl = document.getElementById('header-bell-badge');
    const btn = document.getElementById('header-bell-btn');
    if (badgeEl && btn && !btn.contains(badgeEl)) {
      badgeEl.remove();
      badgeEl = null;
    }
    if (!badgeEl && btn) {
      badgeEl = document.createElement('span');
      badgeEl.id = 'header-bell-badge';
      badgeEl.setAttribute('aria-hidden', 'true');
      btn.appendChild(badgeEl);
    }
    return badgeEl;
  }

  function updateBadge(count) {
    const n = typeof count === 'number' ? count : count ? 1 : 0;
    const badgeEl = ensureBadgeElement();
    if (!badgeEl) return;
    if (n > 0) {
      badgeEl.classList.add('is-visible', 'is-count');
      badgeEl.textContent = n > 99 ? '99+' : String(n);
      badgeEl.style.setProperty('display', 'flex', 'important');
    } else {
      badgeEl.classList.remove('is-visible', 'is-count');
      badgeEl.textContent = '';
      badgeEl.style.setProperty('display', 'none', 'important');
    }
  }

  function updateDrawerUnreadLabel(count) {
    const label = document.getElementById('header-notification-unread-count');
    if (!label) return;
    if (count > 0) {
      label.textContent = '未読 ' + count + '件';
      label.hidden = false;
    } else {
      label.textContent = '';
      label.hidden = true;
    }
  }

  function offerFingerprint(offers) {
    return (offers || [])
      .map(function (m) {
        return String(m.id) + ':' + String(m.content || '');
      })
      .join('|');
  }

  function computeCombinedStatus() {
    const states = [channelStatuses.global];
    if (channelStatuses.request != null) states.push(channelStatuses.request);
    if (states.every(function (s) {
      return s === 'SUBSCRIBED';
    })) {
      return REALTIME_STATUS.LIVE;
    }
    if (states.some(function (s) {
      return s === 'CHANNEL_ERROR' || s === 'TIMED_OUT' || s === 'CLOSED';
    })) {
      return REALTIME_STATUS.RECONNECTING;
    }
    if (states.some(function (s) {
      return s === 'JOINING' || s === 'JOINED';
    })) {
      return REALTIME_STATUS.CONNECTING;
    }
    return REALTIME_STATUS.RECONNECTING;
  }

  function statusMessage(state) {
    if (state === REALTIME_STATUS.LIVE) return 'リアルタイム接続中';
    if (state === REALTIME_STATUS.CONNECTING) return '接続中…';
    if (state === REALTIME_STATUS.RECONNECTING) {
      return '再接続しています…（通知はポーリングで更新中）';
    }
    return '接続できません。ページを再読み込みしてください';
  }

  function ensureRealtimeStatusElements() {
    let drawerStatus = document.getElementById('buyback-realtime-status');
    const drawer = document.getElementById('header-notification-drawer');
    if (!drawerStatus && drawer) {
      drawerStatus = document.createElement('div');
      drawerStatus.id = 'buyback-realtime-status';
      drawerStatus.className = 'buyback-realtime-status';
      drawerStatus.setAttribute('role', 'status');
      drawerStatus.setAttribute('aria-live', 'polite');
      const listEl = document.getElementById('header-notification-list');
      if (listEl) {
        drawer.insertBefore(drawerStatus, listEl);
      } else {
        drawer.appendChild(drawerStatus);
      }
    }

    let bellDot = document.getElementById('header-bell-realtime-dot');
    if (bellDot) bellDot.remove();

    return { drawerStatus: drawerStatus, bellDot: null };
  }

  function updateRealtimeStatusUI(state) {
    const message = statusMessage(state);
    const els = ensureRealtimeStatusElements();

    if (els.drawerStatus) {
      els.drawerStatus.className = 'buyback-realtime-status buyback-realtime-status--' + state;
      els.drawerStatus.textContent = message;
      els.drawerStatus.hidden = state === REALTIME_STATUS.LIVE;
    }

    if (els.bellDot) {
      els.bellDot.remove();
    }

    window.dispatchEvent(
      new CustomEvent('buyback-realtime-status', {
        detail: { state: state, message: message },
      })
    );
  }

  function onChannelStatus(channelKey, status) {
    channelStatuses[channelKey] = status;
    const combined = computeCombinedStatus();
    updateRealtimeStatusUI(combined);

    if (status === 'SUBSCRIBED') {
      reconnectAttempts = 0;
      if (reconnectTimer) {
        clearTimeout(reconnectTimer);
        reconnectTimer = null;
      }
    } else if (status === 'CLOSED' || status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') {
      scheduleReconnect();
    }
  }

  function makeSubscribeHandler(channelKey) {
    return function (status) {
      onChannelStatus(channelKey, status);
      if (status === 'SUBSCRIBED' && channelKey === 'request') {
        refreshHeaderNotifications();
      }
    };
  }

  function scheduleReconnect() {
    if (reconnectTimer || !db) return;
    const delay = Math.min(1000 * Math.pow(2, reconnectAttempts), MAX_RECONNECT_DELAY);
    reconnectAttempts += 1;
    updateRealtimeStatusUI(REALTIME_STATUS.RECONNECTING);
    reconnectTimer = setTimeout(function () {
      reconnectTimer = null;
      reconnectAllChannels();
    }, delay);
  }

  function reconnectAllChannels() {
    if (!db) return;

    const reqId = activeRequestId;
    if (messagesChannel) {
      try {
        db.removeChannel(messagesChannel);
      } catch (e) {}
      messagesChannel = null;
    }
    if (realtimeChannel) {
      try {
        db.removeChannel(realtimeChannel);
      } catch (e) {}
      realtimeChannel = null;
    }

    channelStatuses.global = 'connecting';
    channelStatuses.request = reqId ? 'connecting' : null;
    updateRealtimeStatusUI(computeCombinedStatus());

    setupGlobalMessagesRealtime();
    if (reqId) setupRealtime(reqId, true);
    refreshHeaderNotifications();
    window.dispatchEvent(new CustomEvent('buyback-realtime-reconnect'));
  }

  function ensureBellVisible() {
    const wrapper = document.querySelector('.header-notification-wrapper');
    const btn = document.getElementById('header-bell-btn');
    if (wrapper) {
      wrapper.style.display = 'inline-flex';
      wrapper.style.visibility = 'visible';
      wrapper.style.opacity = '1';
      wrapper.style.flexShrink = '0';
      wrapper.style.position = 'relative';
      wrapper.style.zIndex = '5';
    }
    if (btn) {
      btn.style.display = 'flex';
      btn.style.visibility = 'visible';
      btn.style.opacity = '1';
    }
    document.querySelectorAll('.buyback-global-badge').forEach(function (el) {
      el.remove();
    });
  }

  function buildOfferCardHtml(offer) {
    const val = Number(String(offer.content).split(':')[1]);
    const offerDate = new Date(offer.created_at);
    const dateStr =
      offerDate.getFullYear() +
      '/' +
      String(offerDate.getMonth() + 1).padStart(2, '0') +
      '/' +
      String(offerDate.getDate()).padStart(2, '0') +
      ' ' +
      String(offerDate.getHours()).padStart(2, '0') +
      ':' +
      String(offerDate.getMinutes()).padStart(2, '0');

    const unread = isOfferUnread(offer.id);
    return (
      '<div class="buyback-offer-notification' +
      (unread ? ' is-unread' : ' is-read') +
      '" data-offer-id="' +
      String(offer.id) +
      '" onclick="if(window.openBuybackFromNotification){window.openBuybackFromNotification();return;}if(window.markBuybackOffersAsRead)window.markBuybackOffersAsRead();window.location.href=\'/pages/buyback\'">' +
      '<div class="buyback-offer-notification__head">' +
      '<span class="buyback-offer-notification__title">フィギュア買取査定' +
      (unread ? '<span class="buyback-offer-notification__new">未読</span>' : '') +
      '</span>' +
      '<span class="buyback-offer-notification__date">' +
      dateStr +
      '</span></div>' +
      '<span class="buyback-offer-notification__body">査定額（¥' +
      (Number.isFinite(val) ? val.toLocaleString() : '-') +
      '）が提示されました！<br>タップして確認してください。</span></div>'
    );
  }

  function formatNotificationDate(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return (
      d.getFullYear() +
      '/' +
      String(d.getMonth() + 1).padStart(2, '0') +
      '/' +
      String(d.getDate()).padStart(2, '0') +
      ' ' +
      String(d.getHours()).padStart(2, '0') +
      ':' +
      String(d.getMinutes()).padStart(2, '0')
    );
  }

  function buildUserNotificationCardHtml(n) {
    const unread = !n.is_read;
    const dateStr = formatNotificationDate(n.created_at);
    const bodyHtml = escapeHtml(n.message || '').replace(/\n/g, '<br>');
    return (
      '<div class="header-user-notification' +
      (unread ? ' is-unread' : ' is-read') +
      '">' +
      '<div class="header-user-notification__title">' +
      '<span>' +
      escapeHtml(n.title || '') +
      (unread ? '<span class="buyback-offer-notification__new">未読</span>' : '') +
      '</span>' +
      (dateStr ? '<span class="buyback-offer-notification__date">' + dateStr + '</span>' : '') +
      '</div>' +
      '<div class="header-user-notification__body">' +
      bodyHtml +
      '</div></div>'
    );
  }

  function buildUserNotificationHtml(notifications) {
    return (notifications || []).map(buildUserNotificationCardHtml).join('');
  }

  function buildMergedNotificationHtml() {
    var items = [];
    (cachedOffers || []).forEach(function (offer) {
      if (!offer) return;
      items.push({
        type: 'offer',
        at: offer.created_at ? new Date(offer.created_at).getTime() : 0,
        offer: offer,
      });
    });
    (cachedUserNotifications || []).forEach(function (n) {
      if (!n) return;
      items.push({
        type: 'user',
        at: n.created_at ? new Date(n.created_at).getTime() : 0,
        notification: n,
      });
    });
    items.sort(function (a, b) {
      return b.at - a.at;
    });
    return items
      .map(function (item) {
        if (item.type === 'offer') return buildOfferCardHtml(item.offer);
        return buildUserNotificationCardHtml(item.notification);
      })
      .join('');
  }

  function renderFromCache() {
    ensureBellVisible();

    cachedOffers = filterByNotificationRetention(cachedOffers);
    cachedUserNotifications = filterByNotificationRetention(cachedUserNotifications);

    const offers = cachedOffers || [];
    currentOfferIds = offers.map(function (m) {
      return m.id;
    });

    const unreadCount = getTotalUnreadCount();
    const hasUnreadOffers = getUnreadOfferCount() > 0;

    // 一覧 DOM が無くてもバッジは必ず更新する
    updateBadge(unreadCount);
    updateDrawerUnreadLabel(unreadCount);
    renderShopNews();

    const listEl = document.getElementById('header-notification-list');
    if (listEl) {
      var nextHtml = buildMergedNotificationHtml();
      if (listEl.dataset.notifyHtmlFp !== nextHtml) {
        listEl.dataset.notifyHtmlFp = nextHtml;
        listEl.innerHTML = nextHtml;
      }
    }

    lastOfferFingerprint = offerFingerprint(offers);

    window.dispatchEvent(
      new CustomEvent('buyback-notifications-updated', {
        detail: { offerMessages: offers, showBadge: hasUnreadOffers },
      })
    );
  }

  function mergeOffer(offer) {
    if (!offer || !offer.id || !isOfferMessage(offer.content)) return false;
    if (!isWithinNotificationRetention(offer.created_at)) return false;
    const exists = cachedOffers.some(function (m) {
      return String(m.id) === String(offer.id);
    });
    if (exists) return false;
    cachedOffers = mergeOfferLists(cachedOffers, [offer]);
    return true;
  }

  function mergeOfferLists() {
    var byId = {};
    var lists = Array.prototype.slice.call(arguments);
    lists.forEach(function (list) {
      (list || []).forEach(function (m) {
        if (!m || !m.id || !isOfferMessage(m.content)) return;
        if (!isWithinNotificationRetention(m.created_at)) return;
        byId[String(m.id)] = m;
      });
    });
    return Object.keys(byId)
      .map(function (id) {
        return byId[id];
      })
      .sort(function (a, b) {
        return new Date(a.created_at) - new Date(b.created_at);
      });
  }

  function applyOffersImmediately(offers) {
    const list = (offers || []).filter(function (m) {
      return isOfferMessage(m.content) && isWithinNotificationRetention(m.created_at);
    });
    if (!list.length && !cachedOffers.length) return;

    // 進行中案件の同期で過去分を消さない（マージ＋3か月超のみ除外）
    cachedOffers = mergeOfferLists(cachedOffers, list);

    const nextFp = offerFingerprint(cachedOffers);
    if (nextFp !== lastOfferFingerprint) {
      renderFromCache();
    } else {
      ensureBellVisible();
      const unreadCount = getTotalUnreadCount();
      updateBadge(unreadCount);
      updateDrawerUnreadLabel(unreadCount);
    }
  }

  function applySingleOfferImmediately(offer) {
    if (!offer || !isWithinNotificationRetention(offer.created_at)) return;
    if (!mergeOffer(offer)) return;
    renderFromCache();
  }

  function setupRealtime(requestId, force) {
    if (!db || !requestId) return;
    if (!force && activeRequestId === requestId && realtimeChannel) return;

    if (realtimeChannel) {
      try {
        db.removeChannel(realtimeChannel);
      } catch (e) {}
      realtimeChannel = null;
    }

    activeRequestId = requestId;
    realtimeChannel = db
      .channel('buyback_header_notify_' + requestId + '_' + Date.now())
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'buyback_messages',
          filter: 'request_id=eq.' + requestId,
        },
        function (payload) {
          const row = payload && payload.new;
          if (row && isOfferMessage(row.content)) {
            applySingleOfferImmediately(row);
          }
          refreshHeaderNotifications();
        }
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'buyback_messages',
          filter: 'request_id=eq.' + requestId,
        },
        function (payload) {
          const row = payload && payload.new;
          if (row && isOfferMessage(row.content)) {
            applySingleOfferImmediately(row);
          }
          refreshHeaderNotifications();
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'buyback_requests',
          filter: 'id=eq.' + requestId,
        },
        function () {
          refreshHeaderNotifications();
        }
      )
      .subscribe(makeSubscribeHandler('request'));
  }

  function setupGlobalMessagesRealtime() {
    if (!db || messagesChannel) return;
    messagesChannel = db
      .channel('buyback_header_all_offers_' + Date.now())
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'buyback_messages',
        },
        function (payload) {
          const row = payload && payload.new;
          if (!row || !isOfferMessage(row.content)) return;
          if (activeRequestId && String(row.request_id) !== String(activeRequestId)) {
            refreshHeaderNotifications();
            return;
          }
          applySingleOfferImmediately(row);
          refreshHeaderNotifications();
        }
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'user_notifications',
        },
        function () {
          refreshHeaderNotifications();
        }
      )
      .subscribe(makeSubscribeHandler('global'));
  }

  async function refreshHeaderNotifications() {
    if (refreshInFlight) {
      refreshQueued = true;
      return refreshInFlight;
    }

    refreshInFlight = (async function () {
      ensureBellVisible();
      if (!db) return;

      try {
        const buybackCustomerId = getBuybackCustomerId();
        const cutoffIso = getNotificationCutoffIso();
        let offerMessages = filterByNotificationRetention(cachedOffers);

        if (buybackCustomerId) {
          // 完了・キャンセルも含め、3か月以内の案件から査定お知らせを残す
          const { data: reqs } = await db
            .from('buyback_requests')
            .select('id, status, offered_price, shopify_customer_id, created_at, updated_at')
            .eq('shopify_customer_id', buybackCustomerId)
            .gte('updated_at', cutoffIso)
            .order('created_at', { ascending: false })
            .limit(50);

          if (reqs && reqs.length > 0) {
            var activeReq = null;
            for (var ri = 0; ri < reqs.length; ri++) {
              var st = String(reqs[ri].status || '');
              if (st !== 'completed' && st !== 'cancelled') {
                activeReq = reqs[ri];
                break;
              }
            }
            if (!activeReq) activeReq = reqs[0];
            setupRealtime(activeReq.id);

            var reqIds = reqs.map(function (r) { return r.id; });
            const { data: msgs } = await db
              .from('buyback_messages')
              .select('*')
              .in('request_id', reqIds)
              .gte('created_at', cutoffIso)
              .order('created_at', { ascending: true });

            const fetched = (msgs || []).filter(function (m) {
              return isOfferMessage(m.content);
            });

            // DB取得分で置き換え（3か月超は除外）。Realtime先着分は同期間内なら残る
            offerMessages = mergeOfferLists(fetched);
          } else {
            // 3か月以内の案件が無い → 査定お知らせは期限切れ扱い
            offerMessages = [];
            activeRequestId = null;
            if (realtimeChannel) {
              try {
                db.removeChannel(realtimeChannel);
              } catch (e) {}
              realtimeChannel = null;
            }
            channelStatuses.request = null;
            updateRealtimeStatusUI(computeCombinedStatus());
          }
        }

        cachedOffers = filterByNotificationRetention(offerMessages);
        cachedUserNotifications = await fetchUserNotifications();
        renderFromCache();
      } catch (err) {
        console.error('Buyback notification refresh error:', err);
        cachedOffers = filterByNotificationRetention(cachedOffers);
        renderFromCache();
      } finally {
        refreshInFlight = null;
        if (refreshQueued) {
          refreshQueued = false;
          refreshHeaderNotifications();
        }
      }
    })();

    return refreshInFlight;
  }

  function syncBuybackOfferNotifications(offers) {
    applyOffersImmediately(offers || []);
    refreshHeaderNotifications();
  }

  function markBuybackOffersAsRead() {
    currentOfferIds.forEach(function (id) {
      localStorage.setItem('bell_read_' + id, 'true');
    });
    if (cachedOffers.length) {
      const latestId = String(cachedOffers[cachedOffers.length - 1].id);
      localStorage.setItem('bell_seen_latest_offer', latestId);
    }
    markShopNewsAsRead();
    markUserNotificationsAsRead();
    renderFromCache();
  }

  async function markUserNotificationsAsRead() {
    var unread = (cachedUserNotifications || []).filter(function (n) {
      return n && !n.is_read;
    });
    if (!unread.length) return;
    // まず画面上を即既読にする（DB反映待ちでもバッジを消す）
    cachedUserNotifications = (cachedUserNotifications || []).map(function (n) {
      return Object.assign({}, n, { is_read: true });
    });
    renderFromCache();
    if (!db) return;
    var ids = unread.map(function (n) { return n.id; }).filter(Boolean);
    var userIds = getNotificationUserIds();
    try {
      var updErr = null;
      if (ids.length) {
        var res = await db.from('user_notifications').update({ is_read: true }).in('id', ids);
        updErr = res && res.error;
      }
      if (updErr || !ids.length) {
        await db.rpc('mark_user_notifications_read', { p_user_ids: userIds });
      }
    } catch (e) {
      console.warn('mark user notifications read failed', e);
    }
  }

  function startPolling() {
    if (pollTimer) return;
    pollTimer = setInterval(function () {
      refreshHeaderNotifications();
    }, FALLBACK_POLL_MS);
  }

  function startVisibilityGuard() {
    if (visibilityTimer) return;
    visibilityTimer = setInterval(function () {
      ensureBellVisible();
      ensureBadgeElement();
      const unreadCount = getTotalUnreadCount();
      updateBadge(unreadCount);
      updateDrawerUnreadLabel(unreadCount);
    }, 2000);
  }

  function initDb() {
    if (window._supabase_buyback_client) {
      db = window._supabase_buyback_client;
      return true;
    }
    if (typeof supabase !== 'undefined') {
      db = supabase.createClient(SUPABASE_URL, SUPABASE_KEY, {
        realtime: { params: { eventsPerSecond: 10 } },
      });
      window._supabase_buyback_client = db;
      return true;
    }
    return false;
  }

  function init() {
    initShopNews();
    if (initialized) return;
    if (!initDb()) {
      setTimeout(init, 50);
      return;
    }

    initialized = true;
    updateRealtimeStatusUI(REALTIME_STATUS.CONNECTING);
    setupGlobalMessagesRealtime();
    refreshHeaderNotifications();
    startPolling();
    startVisibilityGuard();

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        refreshHeaderNotifications();
        if (computeCombinedStatus() !== REALTIME_STATUS.LIVE) {
          reconnectAllChannels();
        }
      }
    });

    document.addEventListener('shopify:section:load', function () {
      ensureBellVisible();
      ensureBadgeElement();
      refreshHeaderNotifications();
    });
  }

  function initShopNews() {
    renderShopNews();
    const unreadCount = getTotalUnreadCount();
    updateBadge(unreadCount);
    updateDrawerUnreadLabel(unreadCount);
  }

  function openBuybackFromNotification() {
    if (typeof markBuybackOffersAsRead === 'function') markBuybackOffersAsRead();
    var path = String((window.location && window.location.pathname) || '');
    if (path.indexOf('/pages/buyback') !== -1) {
      var drawer = document.getElementById('header-notification-drawer');
      if (drawer) drawer.style.display = 'none';
      var bell = document.getElementById('header-bell-btn');
      if (bell) bell.setAttribute('aria-expanded', 'false');
      return;
    }
    window.location.href = '/pages/buyback';
  }

  window.refreshHeaderNotifications = refreshHeaderNotifications;
  window.refreshBuybackNotifications = refreshHeaderNotifications;
  window.syncBuybackOfferNotifications = syncBuybackOfferNotifications;
  window.markBuybackOffersAsRead = markBuybackOffersAsRead;
  window.openBuybackFromNotification = openBuybackFromNotification;
  window.reconnectBuybackRealtime = reconnectAllChannels;
  window.getBuybackRealtimeStatus = computeCombinedStatus;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
